/* eslint-disable check-file/filename-blocklist */
import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const invisibleTableHeaderTextStyle = css({
	border: 0,
	clip: 'rect(1px, 1px, 1px, 1px)',
	clipPath: 'inset(50%)',
	height: '1px',
	overflow: 'hidden',
	padding: token('space.0'),
	position: 'absolute',
	width: '1px',
	// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-important-styles
	wordWrap: 'normal !important',
});

export const InvisibleTableHeaderText = (props) => (
	<span css={invisibleTableHeaderTextStyle} {...props} />
);

const styledTableCss = css({
	// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-nested-selectors
	table: {
		border: 'none',
	},
	// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-nested-selectors
	'table > thead, table > tbody': {
		border: 'none',
	},
	// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-nested-selectors
	'table > thead > tr > th': {
		padding: token('space.0'),
		border: 'none',
	},
	// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-nested-selectors
	'table > tbody > tr:hover': {
		backgroundColor: 'inherit',
	},
	// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-nested-selectors
	'table > tbody > tr > td': {
		padding: token('space.050'),
	},
});

export const StyledTable = (props) => <div css={styledTableCss} {...props} />;
